import {
  UPDATE_ROUTES_NAVIGATE,
  RESET_ROUTES_NAVIGATE,
  type TNewRoureStack,
} from './types'

export const updateRouteNavigate = (payload: TNewRoureStack) => ({
  type: UPDATE_ROUTES_NAVIGATE,
  payload,
});
export const resetRouteNavigate = () => ({
  type: RESET_ROUTES_NAVIGATE,
});
